// import Button from 'components/_UI/Button';
import { useCollapse } from 'context/general/Collapse';
// import CircularButton from 'components/_UI/CircularButton';
// import Icon from 'components/_UI/Icon';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
// import colors from 'theme/colors';
// import paths from 'routes/paths';
import indexPriority from 'theme/z-index';
// import EventForm from '../form/EventForm';
// import userApi from 'api/requests/user';
// import { useUser } from 'context/user/User';

export default function FloatingSidebar() {
    const { collapse, setCollapse } = useCollapse();
    // const { user, setUser } = useUser();

    // useEffect(() => {
    //     getUserData()
    // }, []);

    // const showEventForm = () => {
    //     setCollapse({
    //         ...collapse,
    //         withContent: true,
    //         height: '95vh',
    //         arrowPosition: false,
    //         componentToRender: () => <EventForm />
    //     })
    // };

    // async function getUserData() {
    //     try {
    //         const {data} = await userApi.me()
    //         setUser(data)
    //     } catch (error) {
    //         console.log('error')
    //     }
    // };

    return (
        <>
            <FloatingContainer>
                {/* <Button size='medium' variant='pink'>
                    <TrendIconContainer>
                        <Icon name='fire-filled' color={colors.neutralLight} />
                    </TrendIconContainer>
                    Em alta
                </Button> */}

                {/* {
                    user?.avatar hoje e
                    ? <CircularButton image={user?.avatar} />
                    : <CircularButton 
                        path={`${paths.users}${user?.username}`} 
                        withLetter={user?.first_name} 
                    />
                } */}
                

                {/* <CircularButton icon='home' path={paths.home} /> */}
{/* 
                <CircularButton icon='add' onButtonClick={() => showEventForm()} />

                <CircularButton
                    icon='notification'
                    notification={200}
                    notificationColor={colors.occasionalPink}
                />

                <CircularButton
                    icon='mail'
                    notification={12}
                    notificationColor={colors.goldLight}
                /> */}
            </FloatingContainer>
        </>
    )
};

const FloatingContainer = styled(Column)`
    width: auto;
    height: 100px;
    position: absolute;
    right: 3%;
    top: 5%;
    z-index: ${indexPriority.normal};
    align-items: flex-end;
`;

const TrendIconContainer = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 2px;
`